import queryString from "query-string";
import useSWR from "swr";
import type { SwrReturnType } from "~/models/Api";
import type { ConstructionItemSettingEdit } from "~/models/ConstructionItemSetting";
import { generatePath } from "~/utils/generatePath";

export const buildIndexPath = (companyMasterId: number): string =>
	queryString.stringifyUrl({
		query: { company_master_id: companyMasterId },
		url: generatePath("/vendors/construction_item_settings")
	});

export const useConstructionItemSettings = (
	companyMasterId: number
): SwrReturnType<ConstructionItemSettingEdit[]> => {
	const { data, mutate, error, isLoading } = useSWR<
		ConstructionItemSettingEdit[]
	>(buildIndexPath(companyMasterId));

	return {
		data: data ?? null,
		error,
		isLoading,
		mutate
	};
};
